$.fancybox.defaults.touch = false;